@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../../../../constants/spacing.module.less';

.barcode-chip {
  width: 100%;
  display: flex;
  align-items: center;
  gap: @space-8;
  border: 1px solid var(--gray-CFD1D3);
  border-radius: 4px;
  padding: 0 @space-8;
  height: 32px;
  background: var(--gray-F4F6F8);
  min-width: 0;
}

.barcode-chip-error {
  border-color: var(--red-FF4422);
}

.auto-tag {
  flex-shrink: 0;
  background: var(--green-B6F6D7);
  color: var(--green-0B5C35);
  border-radius: 3px;
  padding: 1px @space-4;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  text-transform: uppercase;
}

.barcode-value {
  flex: 1;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.icon-btn {
  flex-shrink: 0;
  padding: @space-4;
  color: var(--gray-637381);
  line-height: 1;
}

.icon-btn:hover {
  color: var(--gray-212B36);
}

.manual-input {
  flex: 1;
  min-width: 0;
}

.use-auto-btn {
  flex-shrink: 0;
  white-space: nowrap;
  height: 32px;
}
